import type { FC } from 'react';

import { useLinkToExplorer } from '@/dbt-explorer';
import { useUrlProjectParams } from '@/hooks/params';
import { NavigationResourceType } from '@/panel/ResourcesFilter/selectedResource';
import { ResourceTypeCard } from './ResourceTypeCard';

type ResourceCountCardProps = {
  resourceType: NavigationResourceType;
  count?: number;
  skeleton?: boolean;
};

export const ResourceCountCard: FC<ResourceCountCardProps> = ({
  resourceType,
  count,
  skeleton = false,
}) => {
  const projectScope = useUrlProjectParams();
  const resourceFilter = useLinkToExplorer('resourceFilter')({
    ...projectScope,
    resourceType: resourceType,
  });
  return (
    <ResourceTypeCard
      resourceType={resourceType}
      href={resourceFilter}
      skeleton={skeleton}
    >
      <p className="text-[20px] font-medium">
        {count !== undefined ? count.toLocaleString() : '-'}
      </p>
    </ResourceTypeCard>
  );
};
